import { render, staticRenderFns } from "./DisciplinaryEditModal.vue?vue&type=template&id=25aa1ed6"
import script from "./DisciplinaryEditModal.vue?vue&type=script&lang=js"
export * from "./DisciplinaryEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports